import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import {router} from './routes/mainroutes'
import {store} from './store/store'
import axios from 'axios'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vuelidate from 'vuelidate'

//import JsonExcel from 'vue-json-excel'
 
import "@/plugins/echarts";

import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker)

//Vue.component('downloadExcel', JsonExcel)

Vue.use(Vuelidate)
Vue.use(VueRouter);

// import CKEditor from '@ckeditor/ckeditor5-vue';

// Vue.use( CKEditor );


//by vrushali
import VueMathjax from 'vue-mathjax';
Vue.use(VueMathjax);
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

import VueSession from 'vue-session' //not use for storing user authentication data
var options = {
    persist: true
}
Vue.use(VueSession, options) 

//Vue.use( CKEditor );
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

///////////////////////AES
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)
//////////////////////

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_URL //live or local
//axios.defaults.baseURL = process.env.VUE_APP_API_URL_BETA //beta
axios.interceptors.request.use(config =>{
 // console.log("req-int"+navigator.onLine)
  if(!navigator.onLine){
    alert("You are offline!!!")
  }
  if(localStorage.getItem("EPS-token"))
    config.headers.common['EPS-token']=localStorage.getItem("EPS-token")
  if(localStorage.getItem("EPS-org-id"))
    config.headers.common['EPS-org-id']=localStorage.getItem("EPS-org-id")
  if(localStorage.getItem("EPS-tenant"))
    config.headers.common['EPS-tenant']=localStorage.getItem("EPS-tenant")
  if(localStorage.getItem("EPS-uid"))
    config.headers.common['EPS-uid']=localStorage.getItem("EPS-uid") 
  if(localStorage.getItem("EPS-bypassed-by"))
    config.headers.common['EPS-bypassed-by']=localStorage.getItem("EPS-bypassed-by")
  if (localStorage.getItem("EPS-AY"))
    config.headers.common['EPS-AY'] = localStorage.getItem("EPS-AY")  
  if (localStorage.getItem("admission-ay"))
    config.headers.common['admission-ay'] = localStorage.getItem("admission-ay")  
  if (localStorage.getItem("myip"))
    config.headers.common['myip'] = localStorage.getItem("myip")  
  // if (localStorage.getItem("EPS-Client"))
  config.headers.common['EPS-Client'] = 'WEB'
  config.headers.common['router-path']=router.currentRoute.path
  return config
})  
axios.interceptors.response.use(res =>{
  // console.log("res",res)
  if(res.data.platform_notification != undefined && store.getters.notification!=res.data.platform_notification){
    store.commit("setnotification", res.data.platform_notification);
    alert("Note: "+res.data.platform_notification)
}
  if(res.data.msg=="200"){
    if(res.data.token_status=="token-refreshed")
      localStorage.setItem("EPS-token",res.data.token)
  }
  else if(res.data.msg=="401"){
    localStorage.setItem('login-page-msg',"You are already logged in on a different device. Please login again")
    router.push("/")
  }
  else if(res.data.msg=="403"){
    localStorage.setItem('login-page-msg',"Access Denied!!!")
    router.push("/access-denied")
  }
  else if(res.data.msg=="404"){
    //alert("Session expired!!!")
    localStorage.setItem('login-page-msg',"Session expired!!!.  Please login again...")
    router.push("/")
  }
  return res
})

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//by vrushali
var converter = require('number-to-words');
Vue.use(converter);

Vue.filter('convertNumbersToWords', function (value) {
  return converter.toWords(value);
})

// var XLSX = require("xlsx");
// Vue.use(XLSX);